// extracted by mini-css-extract-plugin
export default {"processing-message-container":"g__processing-message-container--C5ZDk","processing-message-title":"g__processing-message-title--JcIku"};